module.exports = __webpack_public_path__ + "img/vps.1a9bd7b.png";